var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[_c('Title',{attrs:{"titlePage":_vm.titlePage}})],1),_c('v-container',[_c('PretClientForm',{attrs:{"pret_client":_vm.pret_client,"statuts":_vm.statuts,"mode":_vm.mode},on:{"closeRappel":_vm.closeRappel,"emitPret":_vm.createOrUpdatePret}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }